class CompareProducts {
  constructor() {
    this.productsData = this.loadProductsData();
    this.init();
  }

  loadProductsData() {
    const dataElement = document.getElementById('compare-products-data');
    if (!dataElement) return null;
    
    try {
      return JSON.parse(dataElement.textContent);
    } catch (error) {
      console.error('Error parsing products data:', error);
      return null;
    }
  }

  init() {
    if (!this.productsData) return;

    const selects = document.querySelectorAll('.compare-products__product-select');
    
    for (const select of selects) {
      select.addEventListener('change', (e) => this.handleProductChange(e));
    }
  }

  handleProductChange(event) {
    const select = event.target;
    const productId = select.value;
    const productData = this.productsData.products[productId];
    
    if (!productData) return;

    const productContainer = select.closest('.compare-products__product');
    this.updateProductDisplay(productContainer, productData);
  }

  updateProductDisplay(container, data) {
    const titleEl = container.querySelector('.compare-products__product-title h3');
    if (titleEl) titleEl.textContent = data.title;

    const imageEl = container.querySelector('.compare-products__product-image');
    if (imageEl && data.main_image) {
      imageEl.innerHTML = `<img src="${data.main_image}" alt="${data.title}" width="700" height="700">`;
    }

    const priceEl = container.querySelector('.compare-products__product-price p');
    if (priceEl) priceEl.textContent = data.price;

    const links = container.querySelectorAll('.compare-products__product-link a');
    for (const link of links) {
      link.href = data.url;
    }

    this.updateDenier(container, data.denier);
    this.updateIcon(container, '.compare-products__product-weight', data.weight);
    this.updateIcon(container, '.compare-products__product-waistband', data.waistband);
    this.updateIcon(container, '.compare-products__product-panty-style', data.panty_style);
    this.updateIcon(container, '.compare-products__product-sustainably', data.sustainably);
    this.updateIcon(container, '.compare-products__product-care', data.care);

    const descEl = container.querySelector('.compare-products__product-short_description p');
    if (descEl) {
      const description = typeof data.short_description === 'object' && data.short_description !== null
        ? data.short_description.value || data.short_description.text || ''
        : data.short_description || '';
      descEl.textContent = description;
    }

    this.updateSwatches(container, data);
  }

  updateSwatches(container, data) {
    const swatchContainer = container.querySelector('.compare-products__product-options--color');
    if (!swatchContainer || !data.swatches || data.swatches.length === 0) return;

    let innerHtml = '';
    
    if (data.has_swatch_name) {
      const swatchesHtml = data.swatches
        .map(swatch => `<span data-swatch="${swatch.name}" class="swatch-color-option" style="background-color: ${swatch.color};"></span>`)
        .join('');
      
      innerHtml = `
        <div class="swatch-colors">
          <div class="swatch-options">${swatchesHtml}</div>
        </div>
      `;
    } else {
      const swatchesHtml = data.swatches
        .map(swatch => `
          <span class="opt-label" data-swatch="${swatch.name}" data-variant-group="${swatch.label || swatch.name}">
            <span class="opt-label__text">${swatch.label || swatch.name}</span>
          </span>
        `)
        .join('');
      
      innerHtml = `
        <div class="option-selector option-selector--swatch">${swatchesHtml}</div>
      `;
    }

    innerHtml += `
      <div class="compare-products__product-options--lenght">
        <p>Available in ${data.colors_count || 0} Shades of Nude</p>
      </div>
    `;

    swatchContainer.innerHTML = innerHtml;
  }

  updateDenier(container, denierData) {
    const denierEl = container.querySelector('.compare-products__product-denier');
    if (!denierEl) return;
    
    if (!denierData) {
      denierEl.innerHTML = '';
      return;
    }

    let denierArray = [];
    
    if (typeof denierData === 'string') {
      try {
        const parsed = JSON.parse(denierData);
        denierArray = Array.isArray(parsed) ? parsed : [denierData];
      } catch {
        const cleaned = denierData.replace(/[\[\]"]/g, '');
        denierArray = cleaned.split(',').map(item => item.trim()).filter(item => item);
      }
    } else if (Array.isArray(denierData)) {
      denierArray = denierData;
    } else {
      denierArray = [String(denierData)];
    }

    denierEl.innerHTML = denierArray.map(item => `<p>${item}</p>`).join('');
  }

  updateIcon(container, selector, iconData) {
    const iconEl = container.querySelector(selector);
    if (!iconEl || !iconData) return;

    let html = '';
    
    if (iconData.image) {
      html += `<img src="${iconData.image}" alt="" width="200" height="200">`;
    }
    
    if (iconData.text) {
      html += `<p>${iconData.text}</p>`;
    }

    iconEl.innerHTML = html;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CompareProducts();
});